"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const trustBadges = [{
  id: "google-rating",
  name: "HIPAA Compliant",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612128/img/google_rating_badge.png",
  alt: "HIPAA Compliant Medical Standards"
}, {
  id: "angi-award",
  name: "Board Certified",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612128/img/angi_super_service_badge.png",
  alt: "Board Certified Sleep Specialists"
}, {
  id: "tx-parks",
  name: "Insurance Accepted",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612128/img/texas_parks_wildlife_cert.png",
  alt: "Medical Insurance Providers Accepted"
}, {
  id: "nwco-cert",
  name: "Clinical Excellence",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612128/img/nwco_certification_logo.png",
  alt: "Clinical Excellence in Sleep Apnea Care"
}, {
  id: "licensed-insured",
  name: "AASM Member",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612128/img/licensed_insured_badge.png",
  alt: "American Academy of Sleep Medicine Member"
}];
export default function DfwNeighborhoodTrust() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="145761" id="our-trust-standards" className="bg-background border-y border-border/40 py-10 md:py-14 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`flex flex-col items-center justify-center space-y-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="text-sm md:text-base font-semibold text-muted-foreground text-center uppercase tracking-widest">
            Your Health in Expert Hands
          </p>
          
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 lg:gap-24 w-full max-w-5xl">
            {trustBadges.map((badge, i) => <div key={badge.id} data-index={i} className="flex items-center justify-center group">
                <img src={badge.src} alt={badge.alt} className="h-12 md:h-16 w-auto object-contain grayscale opacity-50 transition-all duration-500 ease-in-out group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-105" loading="lazy" />
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}